export const RenderHtml = ({ wrapperTagName = '', html = null, children, className = '' }) => {
  if (children && children instanceof Object) return children;
  const TagName = wrapperTagName || 'div';
  return <TagName className={className} dangerouslySetInnerHTML={{ __html: html || children }} />;
};
